import { useLocation } from 'react-router'

// Components
import { Link } from 'react-router-dom'

// Utils
import { stringify, parse } from 'querystringify'

type ModalLinkProps = {
  modal: string
  className?: string
  onClick?: (arg: unknown) => unknown
  children: string | JSX.Element
  extraQuery?: Record<string, unknown>
  datatesting?: string
  id?: string
  ariaLabel?: string
}

const ModalLink = ({
  className = '',
  onClick,
  modal,
  extraQuery = {},
  children,
  datatesting,
  id,
  ariaLabel,
}: ModalLinkProps): JSX.Element => {
  const location = useLocation()
  const query = parse(location.search)
  const newSearch = stringify({ ...query, modal, ...extraQuery })
  return (
    <Link
      to={{ pathname: location.pathname, search: newSearch }}
      className={className}
      onClick={onClick}
      datatesting={datatesting}
      id={id}
      aria-label={ariaLabel}
    >
      {children}
    </Link>
  )
}

export default ModalLink
